import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tabs,
} from "@material-ui/core";
import { PageLoading } from "components/UI/Page";
import { HeadTable, Row } from "components/UI/Table";
import TabPanel from "components/UI/Tabs/TabPanel";
import { lang } from "i18nLang";
import { useState } from "react";
import { ExportStore, IndicatorsStore } from "store";
import { formatNumberToMonetary } from "utils";
import {
  columnsAdditives,
  columnsCancellations,
  columnsOtherChanges,
} from "./data/columns";

const useStyles = makeStyles({
  tableContainer: {
    maxHeight: 375,
  },
  headerCell: {
    fontSize: "0.75rem",
    fontWeight: "500 !important" as any,
    backgroundColor: "#FFFFFF !important",
  },
  loading: {
    position: "absolute",
    zIndex: 3,
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
  headerFooter: {
    fontWeight: 700,
  },
});

const IndicatorsAddAndCancelsModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const {
    additivesMoviments,
    cancelationsMoviments,
    otherChangesMoviments,
    additivesTotal,
    cancellationsTotal,
  } = IndicatorsStore;

  const handleChangeTab = (ev, newValue: number) => {
    setCurrentTab(newValue);
  };

  const handleClickExport = () => {
    setLoading(true);
    ExportStore.exportMovimentsData(
      additivesMoviments,
      cancelationsMoviments,
      otherChangesMoviments
    ).finally(() => setLoading(false));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      {loading && <PageLoading className={classes.loading} />}
      <DialogTitle id="form-dialog-title">
        {lang("indicatorsPage.addsAndCancels.modalTitle")}
      </DialogTitle>
      <DialogContent>
        <Tabs
          value={currentTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChangeTab}
        >
          <Tab label={lang("indicatorsPage.addsAndCancels.adds")} />
          <Tab label={lang("indicatorsPage.addsAndCancels.cancels")} />
          <Tab label={lang("indicatorsPage.addsAndCancels.otherChanges")} />
        </Tabs>
        <TabPanel value={currentTab} index={0}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
              <HeadTable
                classNameCell={classes.headerCell}
                columns={columnsAdditives}
              />
              <TableBody>
                {additivesMoviments.map((row) => (
                  <Row columns={columnsAdditives} row={row} />
                ))}
                <TableRow>
                  <TableCell className={classes.headerFooter} colSpan={3}>
                    {lang("fields.total")}
                  </TableCell>
                  <TableCell className={classes.headerFooter} colSpan={3}>
                    {formatNumberToMonetary(additivesTotal)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
              <HeadTable
                classNameCell={classes.headerCell}
                columns={columnsCancellations}
              />
              <TableBody>
                {cancelationsMoviments.map((row) => (
                  <Row columns={columnsCancellations} row={row} />
                ))}
                <TableRow>
                  <TableCell className={classes.headerFooter} colSpan={3}>
                    {lang("fields.total")}
                  </TableCell>
                  <TableCell className={classes.headerFooter} colSpan={3}>
                    {formatNumberToMonetary(cancellationsTotal)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={currentTab} index={2}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
              <HeadTable
                classNameCell={classes.headerCell}
                columns={columnsOtherChanges}
              />
              <TableBody>
                {otherChangesMoviments.map((row) => (
                  <Row columns={columnsOtherChanges} row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={onClose}>
          {lang("close")}
        </Button>
        <Button color="primary" variant="outlined" onClick={handleClickExport}>
          {lang("export")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IndicatorsAddAndCancelsModal;
